// frontend/src/components/dialogs/CompleteConfirmDialog.js

import { LucideSave, BookX } from 'lucide-react';
import { t } from 'i18next';
import { useTheme } from '../../contexts/ThemeContext';
import ConfirmDialogShell from './ConfirmDialogShell';

export const CompleteConfirmDialog = ({ isOpen, onClose, onConfirm, isLoading = false, isDisabled = false }) => {
    const { cn, text } = useTheme();
    return (
        <ConfirmDialogShell
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            isLoading={isLoading}
            isDisabled={isDisabled}
            title={t('completeTrip')}
            confirmIcon={LucideSave}
            cancelIcon={BookX}
        >
            <p className={cn('text-center', text.secondary)}>{t('ConfirmCompleteTrip')}</p>
        </ConfirmDialogShell>
    );
};
export default CompleteConfirmDialog;
